(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.chromotome = {}));
}(this, (function (exports) { 'use strict';

  function map(val, oldMin, oldMax, min, max) {
    return ((val - oldMin) * (max - min)) / (oldMax - oldMin) + min
  }

  exports.map = map;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
